import React from 'react'
import SummaryBudget from './components/SummaryBudget'
import SummaryOptions from './components/SummaryOptions'
import { Micromobility } from 'core-system/Icons/Sidebar'
import SummaryContainerBox from 'features/Programs/Summary/components/SummaryContainerBox'
import wordings from '../Shared/wordings.json'
import palette from 'core-system/Themes/palette'

interface MicromobilitySummaryProps {
  activeOptions: {
    leasing: boolean
    shared: boolean
    oneTime: boolean
  }
  activeMerchantIds: {
    leasing: string[]
    shared: string[]
    oneTime: string[]
  }
  budget: number
}

const QtfSummary = ({
  activeOptions = {
    leasing: false,
    shared: false,
    oneTime: false,
  },
  activeMerchantIds = {
    leasing: [],
    shared: [],
    oneTime: [],
  },
  budget = 0,
}: MicromobilitySummaryProps) => {
  return (
    <SummaryContainerBox title={wordings.micromobility.title}>
      <SummaryOptions
        icon={<Micromobility color={palette.secondary.purple600} />}
        activeOptions={[
          {
            type: 'leasing',
            activeMerchantIds: activeMerchantIds.leasing,
            active: activeOptions.leasing,
          },
          {
            type: 'shared',
            activeMerchantIds: activeMerchantIds.shared,
            active: activeOptions.shared,
          },
          {
            type: 'oneTime',
            activeMerchantIds: activeMerchantIds.oneTime,
            active: activeOptions.oneTime,
          },
        ]}
      />
      <SummaryBudget
        title='Budget'
        lines={[
          {
            title: 'Monthly Budget',
            value: budget,
          },
        ]}
      />
    </SummaryContainerBox>
  )
}

export default React.memo(QtfSummary)
